interface Props {
  label: string;
  value: string | number;
  hint?: string;
  delta?: { value: number; suffix?: string } | null;
}

function DeltaPill({ delta }: { delta: NonNullable<Props['delta']> }) {
  if (!delta || delta.value === 0) {
    return <span className="pill bg-slate-100 text-slate-500">No change</span>;
  }
  const positive = delta.value > 0;
  return (
    <span
      className={
        'pill ' +
        (positive ? 'bg-emerald-100 text-emerald-700' : 'bg-rose-100 text-rose-700')
      }
    >
      <span aria-hidden="true">{positive ? '↑' : '↓'}</span>
      {Math.abs(delta.value)}
      {delta.suffix ?? '%'}
    </span>
  );
}

export function KpiCard({ label, value, hint, delta }: Props) {
  return (
    <div className="card p-4">
      <div className="flex items-center justify-between">
        <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">{label}</p>
        {delta !== undefined && delta !== null ? <DeltaPill delta={delta} /> : null}
      </div>
      <p className="num mt-2 font-display text-3xl font-semibold text-slate-900">{value}</p>
      {hint ? <p className="mt-1 text-xs text-slate-500">{hint}</p> : null}
    </div>
  );
}
